// A07公开卡片仅使用已配置的HTTP(S)资源或本站路径。
export function safeCardUrl(value) {
 const raw=typeof value==='string'?value.trim():'';
 if(!raw||/[\u0000-\u001f\u007f\\]/.test(raw))return '';
 const internal=/^\/(?!\/)/.test(raw);
 if(!internal&&!/^https?:\/\//i.test(raw))return '';
 try {const url=new URL(raw,'http://localhost');return /^https?:$/.test(url.protocol)&&!url.username&&!url.password?(internal?raw:url.href):'';}catch{return '';}
}
export function cardTarget(item, device) {
 const mobile=device==='h5';
 if(item?.linkKind==='LINK'){const url=safeCardUrl(item.linkValue);return mobile&&url.startsWith('/pages/')?'/#'+url:url;}
 if(item?.linkKind==='ACTIVITY')return /^[1-9]\d{0,18}$/.test(String(item.linkValue||''))?(mobile?`/#/pages/activity-detail/index?id=${item.linkValue}`:`/activity/${item.linkValue}`):'';
 const routes=mobile?{DEPOSIT:'/#/pages/deposit/index',WELFARE:'/#/pages/welfare/index',POINTS:'/#/pages/points/index'}:{DEPOSIT:'/mine/finance/deposit',WELFARE:'/mine/record/welfare',POINTS:'/member/points'};
 return routes[item?.linkKind]||'';
}
export function pageCardEntries(page) {
 const items=Array.isArray(page?.items)?page.items:[];
 const entries=items.map((item,index)=>({key:`${page.key}:${index}`,item}));
 if(page?.applicationKey){const index=Math.min(items.length,Math.max(0,(Number(page.applicationPosition)||items.length+1)-1));entries.splice(index,0,{key:'application',application:true});}
 return entries;
}
